import React from "react";
import { ChakraProvider } from '@chakra-ui/react';
import { HashRouter, Routes, Route, Navigate } from "react-router-dom";
import { QueryClient, QueryClientProvider } from 'react-query';
import { Toaster } from 'react-hot-toast';

import AuthLayout from "./layouts/Auth.js";
import RTLLayout from "./layouts/RTL.js";
import { AuthProvider } from './contexts/AuthContext';
import Welcome from "./views/Welcome";


// Import other fonts
import '@fontsource/open-sans/300.css';
import '@fontsource/open-sans/400.css';
import '@fontsource/open-sans/600.css';
import '@fontsource/open-sans/700.css';
import '@fontsource/open-sans/800.css';

import '@fontsource/raleway/300.css';
import '@fontsource/raleway/400.css';
import '@fontsource/raleway/500.css';
import '@fontsource/raleway/600.css';
import '@fontsource/raleway/700.css';

import './index.css'

// Custom Chakra theme
import theme from './theme/theme.js';
import SignInClient from "./views/Auth/Client.js";

// Create a client
const queryClient = new QueryClient();

// Set RTL direction globally
document.documentElement.dir = 'rtl';
document.documentElement.lang = 'fa';

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <ChakraProvider theme={theme} resetCss={false}>
        <AuthProvider>
          <HashRouter>
            <Routes>
              <Route path="/welcome" element={<Welcome />} />
               <Route path="/client" element={<SignInClient />} />
              <Route path="/auth/*" element={<AuthLayout />} />
              <Route path="/*" element={<RTLLayout />} />
            </Routes>
            <Toaster 
              position="top-left"
              toastOptions={{
                duration: 4000,
                style: {
                  background: '#363636',
                  color: '#fff',
                  direction: 'rtl',
                  textAlign: 'right',
                },
              }}
            />
          </HashRouter>
        </AuthProvider>
      </ChakraProvider>
    </QueryClientProvider>
  );
}

export default App; 